import { useTranslation } from "react-i18next";
import { Products as ProductsFeature } from "@/partner/features/products";
import { Meta } from "@/shared/components";

export function ProductsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("products.pageTitle")} pageType="Partner" />
      <ProductsFeature />
    </>
  );
}
